export const reviewsFeedBarWidthExpanded = '300px';
export const reviewsFeedBarWidthShrunk = '75px';